import styled from 'styled-components';
import { StyledAlertDialogContent } from '@/features/auth-managment/styles';
import { Image } from '@/shared/ui/image';

const Wrapper = styled.div`
  padding: 24px 18px;
  height: 90%;

  @media screen and (max-width: 768px) {
    margin-top: 50px;
  }
  @media (orientation: landscape) {
    margin-top: 0;
    padding: 9px;
    height: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  left: 16px;
  right: 16px;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  gap: 50px;

  @media (orientation: landscape) {
    position: relative;
    height: 58px;
    //height: 72px;
    padding: 9px;
    top: 0;
    left: 0;
    right: 0;

    > :nth-child(2) {
      flex: 1;
      height: 100%;
      margin: 0;
      > :nth-child(1) {
        height: 100%;
        margin: 0;
        flex: 1;
      }
    }
  }
`;

const CloseIcon = styled(Image)`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

const MenuList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
  gap: 8px;
  border-radius: 8px;
  margin-top: 15px;
  overflow-y: scroll;
  height: inherit;

  @media (orientation: landscape) {
    grid-template-rows: repeat(2, 1fr);
    //grid-template-columns: auto auto;
    grid-template-columns: repeat(5, 1fr);
    grid-auto-flow: column;
    margin-top: 0;
    height: 100%;
  }
`;

const MenuItem = styled.div`
  min-height: 135px;
  border-radius: 8px;
  background-color: #27262b;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 20px 6px;
  cursor: pointer;

  @media (orientation: landscape) {
    //width: 158px;
    width: 100%;
    gap: 8px;
  }

  &:hover {
    background-color: #3d3c41;
  }

  ${(props) =>
    props.$isDisabled &&
    `
    opacity: 0.4;
    cursor: not-allowed;
  `}
`;

const SelectIconImage = styled.div`
  //position: absolute;
  cursor: pointer;
  display: none;

  @media screen and (max-width: 768px) {
    //top: 20px;
    //left: 18px;
    display: block;
  }
  @media (orientation: landscape) {
    display: block;
  }
`;

const CounterBlock = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background-color: #dd3636;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 8px;
  right: 8px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    font-size: 12px;
  }
`;

const Overlay = styled(StyledAlertDialogContent)`
  background-color: #161639;
`;

export {
  CloseIcon,
  Wrapper,
  MenuList,
  MenuItem,
  SelectIconImage,
  CounterBlock,
  Overlay,
  StyledAlertDialogContent,
};
